// extracted by mini-css-extract-plugin
export default {"skeleton":"VennSkeleton_skeleton__68psv","input":"VennSkeleton_input__taSQs","tables":"VennSkeleton_tables__b3-5U","footer":"VennSkeleton_footer__eYzjM"};